/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Stringcontainsexactoraspect17Inputs */



/**

* @param {_Filter_Class_Stringcontainsexactoraspect17Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_stringcontainsexactoraspect17 = /** @type {((inputs?: _Filter_Class_Stringcontainsexactoraspect17Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Stringcontainsexactoraspect17Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("beinhaltet eins von (exakt)")
});
export { _filter_class_stringcontainsexactoraspect17 as "_filter_class_StringCONTAINSEXACTORAspect" }